import './Footer.css'

function Footer() {
    return (
        <footer className="Footer">built by <a href="https://jonathanjanssens.com">Jonathan Janssens</a></footer>
    )
}

export default Footer
